<div *ngIf="isCreate" class="table-responsive-wrapper">
  <form [formGroup]="createinvoiceForm">
    <div class="invoice-wrapper">
    <div class="invoice-container">

      <!-- Page Header -->
      <!-- <div class="page-header">
        <h2 class="page-title">{{ isEditMode ? 'Edit Invoice' : 'Create Invoice' }}</h2>
      </div> -->

      <!-- Top Section with Logo and Form Fields -->
      <div class="invoice-header-section">

        <!-- Left: Logo Upload -->
        <div class="logo-section">
          <label class="section-label">LOGO</label>
          <div class="logo-upload-container">
            <div class="logo-upload-wrapper">
              <input
                type="file"
                id="imageUpload"
                accept="image/*"
                #fileInput
                (change)="onSelectFile($event)"
                style="display:none;"
              />

              <div class="logo-preview" (click)="fileInput.click()">
                <i
                  *ngIf="shown && !errorMessage"
                  class="fa fa-times logo-remove-btn"
                  (click)="removeImg(); $event.stopPropagation()"
                  aria-hidden="true"
                ></i>

               <img
                  *ngIf="shown"
                  [src]="imageToShow"
                  alt="Logo"
                  (load)="onImageLoad()"
                  (error)="onImageError()"
                />

                <div *ngIf="!shown" class="logo-placeholder">
                  <i class="fa fa-plus"></i>
                </div>
              </div>
            </div>

            <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
          </div>
        </div>

        <!-- Right: Form Fields in Two Columns -->
        <div class="form-fields-section">

          <div class="form-row">

            <!-- Left Column -->
            <div class="left-column">

              <!-- Invoice Number -->
              <div class="form-field">
                <label class="field-label label-flex">Invoice No<span class="required" style="display: contents;">*</span> <span class="helper-text">{{ isEditMode ? 'Editable invoice number' : 'Auto-generated (editable)' }}</span></label>
                <input type="text"
                      formControlName="invoice_code"
                      class="form-input"
                      placeholder="Enter invoice number" />

              </div>

              <!-- Invoice Date -->
              <div class="form-field">
                <label class="field-label">Invoice Date<span class="required">*</span></label>
                <div class="date-input-wrapper">
                  <input
                    id="invdate"
                    #dp="bsDatepicker"
                    bsDatepicker
                    placeholder="Select"
                    (bsValueChange)="selectDurationIn()"
                    (change)="selectClearIn(); clearInDateError()"
                    formControlName="date"
                    [bsValue]="bsValue"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [bsConfig]="{dateInputFormat: 'MMM DD, YYYY', showWeekNumbers:false}"
                    class="form-input dpc"
                    readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"
                  />
                  <img
                    src="assets/img/cal-icon.svg"
                    class="calendar-icon"
                    (click)="dp.show(); $event.stopPropagation()"
                  />
                </div>

                <div *ngIf="submitted" class="error-message">
                  <div *ngIf="!createinvoiceForm.value.date">This field is required</div>
                </div>

                
              </div>

              <!-- Due Date -->
              <div class="form-field">
                <label class="field-label">Due Date<span class="required">*</span></label>
                <div class="date-input-wrapper">
                  <input
                    bsDatepicker
                    id="dueDate"
                    #dp2="bsDatepicker"
                    placeholder="Select"
                    (bsValueChange)="selectDuration()"
                    [min]="date.value"
                    (change)="selectClearDue(); clearDueDateError()"
                    formControlName="duedate"
                    [bsConfig]="{dateInputFormat: 'MMM DD, YYYY', showWeekNumbers:false}"
                    class="form-input dpc"
                    readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"
                  />
                  <img
                    src="assets/img/cal-icon.svg"
                    class="calendar-icon"
                    (click)="dp2.show(); $event.stopPropagation()"
                  />
                </div>
                <div *ngIf="submitted" class="error-message">
                  <div *ngIf="!createinvoiceForm.value.duedate">This field is required</div>
                </div>
                <div *ngIf="date.errors?.['invalidDuration'] || date.errors?.['invalidEqual'] || duedate.errors?.['invalidDurationof'] || duedate.errors?.['invalidEqual']" class="error-message">
                  Due Date can't be earlier than Invoice Date
                </div>
              </div>

              <!-- Select Client -->
              <div class="form-field">
                <label class="field-label">Select Client<span class="required">*</span></label>
                <ng-autocomplete
                  [data]="data"
                  [searchKeyword]="keyword"
                  [initialValue]="selectedClientName"
                  placeholder="Type to select"
                  (selected)="selectEvent($event)"
                  (inputCleared)="onChangeSearch($event)"
                  (inputFocused)="onFocused($event)"
                  [itemTemplate]="itemTemplate"
                  [notFoundTemplate]="notFoundTemplate"
                  class="autocomplete-input"
                ></ng-autocomplete>

                <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.name"></a>
                </ng-template>

                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>

                <div *ngIf="submitted" class="error-message">
                  <div *ngIf="clients.length == 0">This field is required</div>
                </div>
              </div>

              <!-- Select Matter -->
              <div class="form-field" style="margin-top: -13px;">
                <label class="field-label">Select Matter (Optional)</label>
                <select formControlName="matterId" class="form-input matter-select" [disabled]="matterList.length === 0">
                  <option value="">Select Matter</option>
                  <option *ngFor="let matter of matterList" [value]="matter.id">
                    {{ matter.title }}
                  </option>
                </select>
              </div>

            </div>
            
            <!-- Right Column -->
            <div class="right-column">

              <!-- GST (Firm) -->
              <div class="form-field">
                <label class="field-label">GST</label>
                <input
                  type="text"
                  formControlName="gstFirm"
                  placeholder="Enter GST Number"
                  class="form-input"
                  maxlength="15"
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g,'')"
                />
                <div *ngIf="submitted && createinvoiceForm.get('gstFirm')?.invalid" class="error-message">
                  <div *ngIf="createinvoiceForm.get('gstFirm')?.errors?.['pattern']">Invalid GST format</div>
                </div>
              </div>

              <!-- PAN (Firm) -->
              <div class="form-field">
                <label class="field-label">PAN</label>
                <input
                  type="text"
                  formControlName="panFirm"
                  placeholder="Enter PAN Number"
                  class="form-input"
                  maxlength="10"
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g,'')"
                />
                <div *ngIf="submitted && createinvoiceForm.get('panFirm')?.invalid" class="error-message">
                  <div *ngIf="createinvoiceForm.get('panFirm')?.errors?.['pattern']">Invalid PAN format</div>
                </div>
              </div>

              <!-- GST (Client) -->
              <div class="form-field">
                <label class="field-label">Client GST</label>
                <input
                  type="text"
                  formControlName="gstClient"
                  placeholder="Enter GST Number"
                  class="form-input"
                  maxlength="15"
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g,'')"
                />
                <div *ngIf="submitted && createinvoiceForm.get('gstClient')?.invalid" class="error-message">
                  <div *ngIf="createinvoiceForm.get('gstClient')?.errors?.['pattern']">Invalid GST format</div>
                </div>
              </div>

              <!-- PAN (Client) -->
              <div class="form-field">
                <label class="field-label">Client PAN</label>
                <input
                  type="text"
                  formControlName="panClient"
                  placeholder="Enter PAN Number"
                  class="form-input"
                  maxlength="10"
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g,'')"
                />
                <div *ngIf="submitted && createinvoiceForm.get('panClient')?.invalid" class="error-message">
                  <div *ngIf="createinvoiceForm.get('panClient')?.errors?.['pattern']">Invalid PAN format</div>
                </div>
              </div>

              <!-- Client Address -->
              <div class="form-field">
                <label class="field-label">Client Address<span class="required">*</span></label>
                <input
                  type="text"
                  formControlName="billto"
                  placeholder="Address"
                  maxlength="150"
                  [ngModel]="billto"
                  class="form-input"
                  (input)="restrictSpaces($event)"
                  oninput="this.value = this.value.replace(/[^A-Za-z0-9-,_!@$%^*;'&/.()\|# ]|^ /g,'')"
                />
                <div *ngIf="createinvoiceForm.get('billto')?.errors && submitted" class="error-message">
                  <div *ngIf="createinvoiceForm.get('billto')?.errors?.['required']">This field is required</div>
                  <div *ngIf="createinvoiceForm.get('billto')?.errors?.['pattern']">Invalid Pattern</div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- Invoice Items Table -->
      <div class="invoice-items-section">
        <div formArrayName="invoice_items">
          <table class="invoice-table">
            <thead>
              <tr>
                <th class="col-sno">SI.No.</th>
                <th class="col-description">Description</th>
                <th class="col-rate">
                  <div class="rate-header">
                    <span>Rate - {{ selectedCurrency?.code }}</span>
                  </div>
                </th>
                <th class="col-quantity">Quantity</th>
                <th class="col-amount">Amount</th>
                <th class="col-remove"></th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let item of invoiceItemsArray.controls; let i = index"
                [formGroupName]="i"
                class="item-row"
              >
                <td class="text-center">{{ i + 1 }}</td>

                <!-- Description -->
                <td class="description-cell">
                  <textarea
                    formControlName="name"
                    maxlength="250"
                    class="form-input description-textarea"
                    placeholder="Enter description"
                    (input)="sanitizeInput($event)"
                  ></textarea>
                      <span class="char-counter">
                        {{ invoiceItemsArray.controls[i].get('name')?.value?.length || 0 }} / 250 characters
                      </span>

                      <div
                      *ngIf="submitted && invoiceItemsArray.controls[i].get('name')?.invalid"
                      class="error-message">
                      <small *ngIf="invoiceItemsArray.controls[i].get('name')?.errors?.['required']">
                        This field is required.
                      </small>
                    </div>


                </td>

                <!-- Rate -->
                <td class="rate-cell">
                  <div class="currency-input-wrapper">
                    <span class="currency-symbol">₹</span>
                    <input
                      maxlength="10"
                      formControlName="unitPrice"
                      class="form-input rate-input"
                      placeholder="0"
                      (input)="onInput($event, 'unitPrice', i, asFormGroup(item)); restrictFirstPosition($event)"
                      required
                    />
                  </div>
                  <div *ngIf="submitted && invoiceItemsArray.controls[i].get('unitPrice')?.invalid" class="error-message">
                    <small *ngIf="invoiceItemsArray.controls[i].get('unitPrice')?.errors?.['required']">
                      This field is required
                    </small>
                    <small *ngIf="invoiceItemsArray.controls[i].get('unitPrice')?.errors?.['pattern']">
                      Enter valid number
                    </small>
                    <small *ngIf="invoiceItemsArray.controls[i].get('unitPrice')?.errors?.['noZeroStart']">
                      Cannot start with 0
                    </small>
                  </div>
                </td>

                <!-- Quantity -->
                <td class="quantity-cell">
                  <input
                    maxlength="10"
                    formControlName="quantity"
                    class="form-input quantity-input text-center"
                    placeholder="1"
                    (input)="onInput($event, 'quantity', i, asFormGroup(item)); restrictFirstPosition($event)"
                    required
                  />
                  <div *ngIf="submitted && invoiceItemsArray.controls[i].get('quantity')?.invalid" class="error-message">
                    <small *ngIf="invoiceItemsArray.controls[i].get('quantity')?.errors?.['required']">
                      This field is required
                    </small>
                    <small *ngIf="invoiceItemsArray.controls[i].get('quantity')?.errors?.['pattern']">
                      Enter valid number
                    </small>
                  </div>
                </td>

                <!-- Amount -->
                <td class="amount-cell">
                  {{ selectedCurrency.symbol }} {{ calculateAmount(asFormGroup(item)) | number:'1.2-2' }}
                </td>

                <!-- Remove Row -->
                <td class="remove-cell">
                  <i
                    *ngIf="invoiceItemsArray.controls.length > 1"
                    (click)="removeItem(i)"
                    class="fa fa-times remove-icon"
                    title="Remove row"
                    aria-hidden="true"
                  ></i>
                </td>

              </tr>
            </tbody>
          </table>

          <button type="button" class="btn-add-item" (click)="addItem()">
            <i class="fa fa-plus"></i> Add
          </button>

          <div *ngIf="createinvoiceForm.get('invoice_items')?.errors && submitted" class="error-message">
            <div *ngIf="createinvoiceForm.get('invoice_items')?.errors?.['required']">Add at least one Item.</div>
          </div>

        </div>
      </div>

      <!-- Bottom Section: Notes and Totals -->
      <div class="invoice-footer-section">

        <div class="notes-section">
          <label class="section-label">Additional Details</label>
          <textarea
            rows="5"
            class="form-input notes-textarea"
            maxlength="250"
            formControlName="notes"
            placeholder="Please Add Billing Information for Clients"
            oninput="this.value = this.value.replace(/[^A-Za-z0-9-,!@$%^*.;'&/.()# ]|^ /g,'').slice(0,250)"
          ></textarea>
          <span class="char-counter">
            {{ createinvoiceForm.get('notes')?.value?.length || 0 }} / 250 Characters
          </span>
          <div class="thank-you-text">THANK YOU FOR YOUR BUSINESS.</div>
        </div>

        <div class="totals-section">

          <div class="total-row">
            <span class="total-label">Sub Total</span>
            <span class="total-value">{{ selectedCurrency?.symbol }} {{ calculateTotalAmount() | number:'1.2-2' }}</span>
          </div>

          <div class="total-row">
            <span class="total-label">Discount</span>
            <div class="percentage-input-wrapper">
              <input
                placeholder="(%)"
                maxlength="5"
                class="form-input inline-input percentage-input"
                formControlName="discount"
                (input)="onInputDT($event);restrictFirstPosition($event);discountVal($event)"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
              />
              <!-- <span class="percentage-symbol">(%)</span> -->
               <span class="amount">₹ {{ discountAmount | number:'1.2-2' }}</span>
            </div>
          </div>

          <div *ngIf="f['discount'].errors" class="error-message">
            <div *ngIf="f['discount'].errors['max']">Should be less than or equal to 100</div>
            <div *ngIf="f['discount'].errors['pattern']">Accepts only numbers & two decimal places</div>
            <div *ngIf="f['discount'].errors['min']">Should be greater than or equal to 0</div>
          </div>

          <div class="total-row">
            <span class="total-label">Tax</span>
            <div class="percentage-input-wrapper">
              <input
                placeholder="(%)"
                maxlength="5"
                class="form-input inline-input percentage-input"
                formControlName="tax"
                (input)="onInputDT($event);restrictFirstPosition($event);taxVal($event)"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
              />
              <!-- <span class="percentage-symbol">(%)</span> -->
              <span class="amount">₹ {{ taxAmount | number:'1.2-2' }}</span>
            </div>
          </div>

          <div *ngIf="f['tax'].errors" class="error-message">
            <div *ngIf="f['tax'].errors['max']">Should be less than or equal to 100</div>
            <div *ngIf="f['tax'].errors['pattern']">Accepts only numbers & two decimal places</div>
            <div *ngIf="f['tax'].errors['min']">Should be greater than or equal to 0</div>
          </div>

          <div class="total-row total-final">
            <span class="total-label">Total</span>
            <span class="total-value">{{ selectedCurrency?.symbol }} {{ calculateTotalAmountWithOthers() | number:'1.2-2' }}</span>
          </div>

        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button type="button" (click)="onClose()" class="btn btn-cancel btncancel">Cancel</button>
        <span class="save-btn-wrapper">
          <button type="button" (click)="onSubmit()" class="btn btn-save btnsave savecls" [disabled]="isSaveDisabled">
            {{ isEditMode ? 'Update' : 'Save' }}
          </button>
          <span class="save-tooltip-text" *ngIf="isSaveDisabled && saveDisabledReason">{{ saveDisabledReason }}</span>
        </span>
      </div>

    </div>
    </div>
  </form>
</div>

<!-- Save Confirmation Modal (Replace vs Save Both) -->
<div class="modal-overlay" *ngIf="showSaveModal" (click)="showSaveModal = false">
  <div class="modal-dialog-custom" (click)="$event.stopPropagation()">
    <div class="modal-content-custom">
      <button type="button" class="btn-close-custom" (click)="showSaveModal = false">
        <i class="fa fa-times"></i>
      </button>
      
      <div class="modal-header-custom">
        <h3 class="modal-title-custom">Save Changes</h3>
      </div>
      
      <div class="modal-body-custom">
        <p class="modal-message">Do you want to replace the existing invoice or save both?</p>
        
        <div class="modal-info">
          <div class="info-item">
            <i class="fa fa-refresh info-icon"></i>
            <div class="info-text">
              <strong>Replace:</strong> Updates the current invoice with your changes
            </div>
          </div>
          <div class="info-item">
            <i class="fa fa-copy info-icon"></i>
            <div class="info-text">
              <strong>Save Both:</strong> Creates a new invoice while keeping the original
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer-custom">
        <button type="button" class="btn-modal btn-replace" (click)="handleModalAction('replace')">
          <i class="fa fa-refresh"></i> Replace
        </button>
        <button type="button" class="btn-modal btn-save-both" (click)="handleModalAction('saveboth')">
          <i class="fa fa-copy"></i> Save Both
        </button>
      </div>
    </div>
  </div>
</div>